import axios from "axios";

const baseUrl = process.env.REACT_APP_MAIN_API

const axiosApi = axios.create({baseURL: baseUrl})
axiosApi.defaults.headers.get['Content-Type'] = 'application/json'

export default axiosApi